"use client"; // Error boundaries must be Client Components

import PageNotFoundError from "@/components/Error/PageNotFound";

export default function NotFound() {
  return <PageNotFoundError />;
}
